// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
import { StoresInstance } from "Globals/Stores";
import { IsEmail, IsNotEmpty, Equals, IsPhoneNumber } from "class-validator";
// Models

// Dto
import { NewApplicantRequestDTO } from "Globals/Models/DTO/NewApplicantRequestDTO";
import { Amendment } from "Globals/Models/Amendment";
import { FormSectionsEnum } from "Globals/Models/FormSectionsEnum";
import { AmendmentModel } from "./AmendmentModel";

export class AmendmentsModel extends ModelBase<AmendmentsModel> {
    @MobX.observable public formId: string = "";
    @MobX.observable public applicantId: string = "";
    @MobX.observable public amendments: AmendmentModel[] = [];

    @MobX.action
    public fromDto = (model: Amendment[]): void => {
        if (model !== null && model !== undefined) {
            model.forEach((amendment) => {
                let localAmendmentModel: AmendmentModel = new AmendmentModel();
                localAmendmentModel.fromDto(amendment);
                this.amendments.push(localAmendmentModel);
            });
        }
    };

    @MobX.action
    public toDto = (): boolean => {
        return false;
    };
}
